const initial_events  = {
    
    event_data:{
    }
    
};

export default initial_events